import { Pagination as MantinePagination } from '@mantine/core';
import { Ellipsis, ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

export const Pagination = MantinePagination.extend({
	defaultProps: {
		nextIcon: (props) => <ChevronRight {...props} />,
		previousIcon: (props) => <ChevronLeft {...props} />,
		lastIcon: (props) => <ChevronsRight {...props} />,
		firstIcon: (props) => <ChevronsLeft {...props} />,
		dotsIcon: (props) => <Ellipsis {...props} />,
	},
});
